/**
 * IMPORTANT: use this file only to import element from outside of package.
 */

import meta from '../../package.json';
import es from '../i18n/es.json';

export * from './configureStore';
export * from './configureRootSaga';
export * from './configureAmplify';
export * from './apiConfig';
export { default as modalsConfig } from './modalsConfig';

export const I18N = {
  namespace: meta.name,
  bundles: {
    es
  }
};

export const ICONS = [];
